import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import styles from "./QuickDateFilter.module.scss";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const QuickDateFilter = ({ quickFilter, setQuickFilter, onApply }) => {
  const handleQuickFilter = (value) => {
    setQuickFilter(value);

    if (value === "custom_date") {
      onApply("custom_open", "custom_open");
      return;
    }

    const today = new Date();
    let from = new Date();

    switch (value) {
      case "yesterday":
        from.setDate(today.getDate() - 1);
        break;
      case "last_week":
        from.setDate(today.getDate() - 7);
        break;
      case "1_month":
        from.setMonth(today.getMonth() - 1);
        break;
      case "2_months":
        from.setMonth(today.getMonth() - 2);
        break;
      case "3_months":
        from.setMonth(today.getMonth() - 3);
        break;
      default:
        return;
    }

    const fromDate = formatDate(from);
    const toDate = formatDate(today);

    onApply(fromDate, toDate);
  };

  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>Quick Filter</label>

      <div className={styles.selectWrapper}>
        <FaCalendarAlt className={styles.icon} />

        <select
          className={styles.select}
          value={quickFilter}
          onChange={(e) => handleQuickFilter(e.target.value)}
        >
          <option value="">Select</option>
          <option value="yesterday">Yesterday</option>
          <option value="last_week">Last Week</option>
          <option value="1_month">1 Month</option>
          <option value="2_months">2 Months</option>
          <option value="3_months">3 Months</option>
          <option value="custom_date">Custom Date</option>
        </select>
      </div>
    </div>
  );
};

export default QuickDateFilter;
